export const EZ_FORM_SELECT_FIELD_CLOSE = 'ez-form-select-field-close';
export const GO_AHEAD_GET_STICKY = 'go-ahead-get-sticky';
export const SBI_LOAD_FORM_ERRORS = 'sbi-load-form-errors';
export const SBI_CLEAR_DRAG_DROP = 'sbi-clear-drag-drop';
export const DROPZONE_SUBMIT_WITHOUT_FILE = 'dropzone-submit-without-file';
export const DROPZONE_PROCESS_QUEUE = 'dropzone-process-queue';
export const STUDIO_CHAT_INSERT_ATTACHMENT_IMAGES = 'studio-chat-insert-attachment-images';
export const STUDIO_CHAT_APPEND_ATTACHMENTS = 'studio-chat-append-attachments';
export const STUDIO_PROJECT_DESIGNER_CHANGE = 'studio-project-designer-change';
export const STUDIO_PROJECT_NAME_CHANGE = 'studio-project-name-change';
export const STUDIO_PROJECT_APPROVE = 'studio-project-approve';
export const STUDIO_PROJECT_DETAILS_UPDATE_MODAL_CLOSED = 'studio-project-details-update-modal-closed';
export const EZ_CAROUSEL_TRIGGER_REINIT = 'ez-carousel-trigger-reinit';
export const EZ_HOVER_INTENT_IN = 'ez-hover-intent-in';
export const EZ_HOVER_INTENT_OUT = 'ez-hover-intent-out';
export const SHOW_MODAL_LOADED = 'show-modal-loaded';

export type EzCustomEvent = |
  typeof EZ_FORM_SELECT_FIELD_CLOSE |
  typeof GO_AHEAD_GET_STICKY |
  typeof SBI_LOAD_FORM_ERRORS |
  typeof SBI_CLEAR_DRAG_DROP |
  typeof DROPZONE_SUBMIT_WITHOUT_FILE |
  typeof DROPZONE_PROCESS_QUEUE |
  typeof STUDIO_CHAT_INSERT_ATTACHMENT_IMAGES |
  typeof STUDIO_CHAT_APPEND_ATTACHMENTS |
  typeof STUDIO_PROJECT_DESIGNER_CHANGE |
  typeof STUDIO_PROJECT_APPROVE |
  typeof STUDIO_PROJECT_NAME_CHANGE |
  typeof STUDIO_PROJECT_DETAILS_UPDATE_MODAL_CLOSED |
  typeof EZ_CAROUSEL_TRIGGER_REINIT |
  typeof EZ_HOVER_INTENT_IN |
  typeof EZ_HOVER_INTENT_OUT |
  typeof SHOW_MODAL_LOADED
